// @flow
import { useRouter } from 'next/navigation'

export function useAddQueryParam (): (name: string, value: string) => void {
  const router = useRouter()

  const addQueryParam = (name: string, value: string): void => {
    const currentParams = new URLSearchParams(window.location.search) // Get current params
    currentParams.set(name, value) // Add or replace the new param

    const newQueryString = currentParams.toString() // Format the updated params
    const newUrl = `${window.location.pathname}?${newQueryString}`

    router.push(newUrl) // Navigate with the updated query string
  }

  return addQueryParam
}
